import type {
  Kautionsvertrag,
  KautionsvertragPrüfung as KautionsvertragPruefung,
} from '@/types/Vertrag.ts';
import { SharedKreditvertragService } from '@/shared/api/services/partner/kreditvertrag.ts';
import { configForDownload } from '@/connection/base.ts';

export class KreditvertragService extends SharedKreditvertragService {
  async holeKautionsvertragByPruefungId(
    kautionsvertragsPruefungId: string,
  ): Promise<Kautionsvertrag> {
    return this.httpClient.get(`${this.baseUrl}/pruefung/${kautionsvertragsPruefungId}`);
  }

  async downloadVertragDokumentation(kautionsvertragId: number): Promise<BlobPart> {
    return this.httpClient.get(`${this.baseUrl}/${kautionsvertragId}/dokumentation`, {
      config: configForDownload,
    });
  }

  async schliesseVertragsPruefungAbByPruefungsId(
    kautionsvertragsPruefungsId: string,
    pruefung: KautionsvertragPruefung,
  ): Promise<Kautionsvertrag> {
    return this.httpClient.post(
      `${this.baseUrl}/pruefung/${kautionsvertragsPruefungsId}/abschluss`,
      { data: pruefung },
    );
  }
}
